import { AffiliateState } from "../../interfaces/affiliate";

export const affiliateNickname = (
  data: AffiliateState | undefined,
  address: string
) => data?.affiliate_nicknames?.[address.toLowerCase()] || "";

export const affiliateLabel = (
  data: AffiliateState | undefined,
  address: string
) => {
  const nickname = affiliateNickname(data, address);
  return nickname ? `${nickname} · ${address}` : address;
};

export const validAffiliateNickname = (value: string) =>
  Array.from(value.trim()).length <= 64 &&
  Array.from(value).every((character) => {
    const point = character.codePointAt(0)!;
    return (
      point >= 32 &&
      (point < 127 || point > 159) &&
      point !== 8232 &&
      point !== 8233
    );
  });
